import type React from 'react'

import type { Application } from '@/types/Activity'

import OrganisationCreditDetails from './OrganisationCreditDetails'
import OrganisationCreditFallback from './OrganisationFallback'

interface Props {
  application: Application
}

const ForProfitOrganisationDetails: React.FC<Props> = ({ application }) => {
  return (
    <div>
      {application.context?.company?.credit ? (
        <OrganisationCreditDetails credit={application.context?.company?.credit} />
      ) : (
        <OrganisationCreditFallback
          hasVerifiedOrganisation={
            application.context?.company?.verification?.verifiedBy !== undefined
          }
        />
      )}
    </div>
  )
}

export default ForProfitOrganisationDetails
